export default function FilterField({ label, children }) {
    return (
        <div className="flex flex-col ">
            <label className="text-12 font-medium text-gray-700 mt-4">
                {label}
            </label>
            {children}
        </div>
    )
};